import { FieldDef, GroupDef, GuiDef, ValidatorDef, TabDefinition, CollapsableDef } from '@/objects/gui';
import { ShootingResult } from '@/objects/generated';
import { markRaw, computed } from 'vue';
import { InputInt, ValidatedInt, InputNullableInt, InputDateTime, DateComp } from '@/components';
import { type DateType } from '@/utilities/dateutils';
import type { SelectLine, SelectLineValueType } from '@/objects/SelectLine';

export class ShootingResultGuiDef extends GuiDef<ShootingResult> {
    constructor() {
        super('ShootingResult');

        const ShootingNumber = new FieldDef<ShootingResult>();
        ShootingNumber.Name = 'ShootingNumber';
        ShootingNumber.FieldName = 'ShootingNumber';
        ShootingNumber.DefinedFor = 'Both';
        ShootingNumber.TranslationKey = 'shootingresult.shootingnumber';
        ShootingNumber.Editable = true;
        ShootingNumber.Filterable = false;
        ShootingNumber.Sortable = true;
        ShootingNumber.CssClasses = '';
        ShootingNumber.value = (shootingresult) => shootingresult.ShootingNumber;
        ShootingNumber.setValue = (shootingresult, value) => {
            if (value === null || value === undefined || value === '' || isNaN(value)) {
                value = 0;
            }
            shootingresult.ShootingNumber = value;
        };
        ShootingNumber.DetailEditor = markRaw(InputInt);
        ShootingNumber.DetailEditorProps = {};
        ShootingNumber.CellEditor = markRaw(InputInt);
        ShootingNumber.CellEditorProps = {};
        ShootingNumber.CellRenderer = markRaw(ValidatedInt);
        ShootingNumber.CellRendererProps = {};
        ShootingNumber.Validator = null;
        ShootingNumber.SortDirection = undefined;
        ShootingNumber.cellClassRules = undefined;
        ShootingNumber.MinWidth = 100;
        ShootingNumber.MaxWidth = 100;
        ShootingNumber.Tooltip = null;
        this.Fields.push(ShootingNumber);

        const Lane = new FieldDef<ShootingResult>();
        Lane.Name = 'Lane';
        Lane.FieldName = 'Lane';
        Lane.DefinedFor = 'Both';
        Lane.TranslationKey = 'shootingresult.lane';
        Lane.Editable = true;
        Lane.Filterable = false;
        Lane.Sortable = true;
        Lane.CssClasses = '';
        Lane.value = (shootingresult) => shootingresult.Lane;
        Lane.setValue = (shootingresult, value) => {
            if (value === null || value === undefined || value === '' || isNaN(value)) {
                value = 0;
            }
            shootingresult.Lane = value;
        };
        Lane.DetailEditor = markRaw(InputInt);
        Lane.DetailEditorProps = {};
        Lane.CellEditor = markRaw(InputInt);
        Lane.CellEditorProps = {};
        Lane.CellRenderer = markRaw(ValidatedInt);
        Lane.CellRendererProps = {};
        Lane.Validator = null;
        Lane.SortDirection = undefined;
        Lane.cellClassRules = undefined;
        Lane.MinWidth = 100;
        Lane.MaxWidth = 100;
        Lane.Tooltip = null;
        this.Fields.push(Lane);

        const StationId = new FieldDef<ShootingResult>();
        StationId.Name = 'StationId';
        StationId.FieldName = 'StationId';
        StationId.DefinedFor = 'Both';
        StationId.TranslationKey = 'shootingresult.stationid';
        StationId.Editable = true;
        StationId.Filterable = false;
        StationId.Sortable = true;
        StationId.CssClasses = '';
        StationId.value = (shootingresult) => shootingresult.StationId;
        StationId.setValue = (shootingresult, value) => {
            if (value === undefined || value === '' || isNaN(value)) {
                value = null;
            }
            shootingresult.StationId = value;
        };
        StationId.DetailEditor = markRaw(InputNullableInt);
        StationId.DetailEditorProps = {};
        StationId.CellEditor = markRaw(InputNullableInt);
        StationId.CellEditorProps = {};
        StationId.CellRenderer = markRaw(ValidatedInt);
        StationId.CellRendererProps = {};
        StationId.Validator = null;
        StationId.SortDirection = undefined;
        StationId.cellClassRules = undefined;
        StationId.MinWidth = undefined;
        StationId.MaxWidth = undefined;
        StationId.Tooltip = null;
        this.Fields.push(StationId);

        const Time = new FieldDef<ShootingResult>();
        Time.Name = 'Time';
        Time.FieldName = 'Time';
        Time.DefinedFor = 'Both';
        Time.TranslationKey = 'shootingresult.time';
        Time.Editable = true;
        Time.Filterable = true;
        Time.Sortable = true;
        Time.CssClasses = '';
        Time.value = (shootingresult) => shootingresult.Time;
        Time.setValue = (shootingresult, value) => (shootingresult.Time = value);
        Time.DetailEditor = markRaw(InputDateTime);
        Time.DetailEditorProps = { format: 'TIME' as DateType };
        Time.CellEditor = markRaw(InputDateTime);
        Time.CellEditorProps = { format: 'TIME' as DateType };
        Time.CellRenderer = markRaw(DateComp);
        Time.CellRendererProps = { format: 'TIME' as DateType };
        Time.Validator = null;
        Time.SortDirection = undefined;
        Time.cellClassRules = undefined;
        Time.MinWidth = 120;
        Time.MaxWidth = 120;
        Time.Tooltip = null;
        this.Fields.push(Time);
    }

    public async LoadDependencies() {}
}
